"use client";
import { Box, IconButton, Stack } from "@mui/material";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import { Button } from "@/src/components/Button";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { InfoModalData } from "../types";
import { ParsedValue } from "@/src/components/TextWithValue";
import { useStepsNavigation } from "../useStepsNavigation";
import { useState } from "react";
import { useHandleApiCall } from "../useHandleApiCall";

export const InfoModal = ({
  title,
  description = "",
  cancelText = "назад",
  submitText = "Далі",
  buttonsLayout = "vertical",
  withCross,
  onCancel,
  onSubmit,
}: InfoModalData) => {
  const { goBack, goNext, goToStep } = useStepsNavigation();
  const { handleApiCallByName } = useHandleApiCall();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCancel = () => {
    onCancel?.({
      nextStep: goNext,
      prevStep: goBack,
      specificStep: goToStep,
      handleApiCallByName
    });
  };
  const handleSubmit = async () => {
    if (!onSubmit) return;
    setIsSubmitting(true);
    await onSubmit?.({
      nextStep: goNext,
      prevStep: goBack,
      specificStep: goToStep,
      handleApiCallByName,
    });
    setIsSubmitting(false);
  };

  return (
    <Box className="flex w-full max-w-[524px] flex-col gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal overflow-y-auto">
        <Stack className={"w-full flex items-end -mb-6"}>
        
        {withCross && <IconButton onClick={handleCancel} className="max-md:hidden">
          <WebShopIcon name={"close"} className="fill-blue" />
        </IconButton>}
      </Stack>
      <Stack className="flex flex-col gap-2 rounded-lg text-base text-dark-gray">
        <Box className={"flex flex-col items-center justify-center gap-3"}>
          <Box
            className={
              "flex aspect-square w-[68px] items-center justify-center rounded-full bg-[#EEF7FC]"
            }
          >
            <WebShopIcon name="info" width={32} fill="#009DDE" />
          </Box>
          <Box className={"text-lg font-semibold text-dark-gray"}>{title}</Box>
          <Box className={"text-center text-base text-dark-gray"}>
            <ParsedValue value={description} makeBold />
          </Box>
        </Box>
      </Stack>
      <Stack
        className={cn(
          "flex flex-nowrap gap-3 [&>*]:flex-1",
          buttonsLayout === "vertical" ? "flex-col" : "flex-row",
        )}
      >
        {!!onCancel && (
          <Button variant={"outlined"} onClick={handleCancel}>
            {cancelText}
          </Button>
        )}
        {!!onSubmit && <Button onClick={handleSubmit} loading={isSubmitting}>{submitText}</Button>}
      </Stack>
    </Box>
  );
};
